module.exports = __webpack_public_path__ + "img/member_home_logo3.f4478def.jpg";